import { useEffect, useState } from "react";

import { getFilingMaterialsExport } from "../../../api/packets-v2";
import type { FilingMaterialsExport } from "../../../api/utils/filingMaterialsExport";

const POLL_MS = 3000;

/**
 * Follow a filing-materials export the agent started until the ZIP is ready.
 * Exports are not in the workspace tree, so they are polled here directly.
 */
export const useExportRun = (
  individualId: string,
  exportId: string | null
): FilingMaterialsExport | null => {
  const [record, setRecord] = useState<FilingMaterialsExport | null>(null);

  useEffect(() => {
    if (!exportId) return undefined;
    let cancelled = false;
    let timer: ReturnType<typeof setTimeout> | undefined;

    const tick = async () => {
      try {
        const next = await getFilingMaterialsExport(individualId, exportId);
        if (cancelled) return;
        setRecord(next);
        if (next.status === "processing") timer = setTimeout(tick, POLL_MS);
      } catch {
        if (cancelled) return;
        setRecord({
          export_id: exportId,
          status: "failed",
          error: "Couldn't check on the export."
        });
      }
    };
    void tick();

    return () => {
      cancelled = true;
      if (timer) clearTimeout(timer);
    };
  }, [exportId, individualId]);

  return record;
};
